export default {"src":"/_next/static/media/arrow-left.6465dab7.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};